export const setItemAction = (args: {
  route?: any;
  action?: (object) => void;
  content?: string | JSX.Element;
  toggleContent: (object) => void;
  pushRoute: (object) => void;
}) => {
  const { route, action, content, toggleContent, pushRoute } = args;
  if (content) {
    return toggleContent;
  }
  if (route) {
    return pushRoute;
  }
  return action;
};
